import { VectorProps } from './types';

const VS = ({ className, size = 1, color = 'currentColor' }: VectorProps) => (
  <svg className={className} width={`${size}em`} viewBox="0 0 24.101 14.555">
    <g transform="translate(-184.347 -764.685)" fill={color}>
      <path
        d="M216.713,420.159l-5.218,13.849h-2.962L203.3,420.159h3.08l3.648,10.377,3.648-10.377Z"
        transform="translate(-18.949 344.878)"
      />
      <path
        d="M248.109,433.628c-2.628,0-4.59-.9-5.335-2.57a4.621,4.621,0,0,1-.059-3.492c.647-1.412,2.217-2,4.021-2.491,1.668-.451,3.217-.706,3.629-1.589a1.678,1.678,0,0,0,.1-.627,1.378,1.378,0,0,0-.117-.628,2.114,2.114,0,0,0-2.04-.981,2.068,2.068,0,0,0-2.08,1.079,2.968,2.968,0,0,0-.215,1.236h-3a5.011,5.011,0,0,1,.372-2.02c.726-1.608,2.452-2.472,4.806-2.472,2.413,0,4.237.922,4.9,2.452a3.83,3.83,0,0,1,.372,1.648,3.954,3.954,0,0,1-.313,1.55c-.569,1.275-1.962,1.922-3.57,2.354-1.687.49-3.375.745-3.845,1.785a1.651,1.651,0,0,0-.157.726,1.879,1.879,0,0,0,.177.765,2.971,2.971,0,0,0,4.61-.157,3.154,3.154,0,0,0,.216-1.275h3.2a5.416,5.416,0,0,1-.412,2.1C252.64,432.608,250.874,433.628,248.109,433.628Z"
        transform="translate(-45.33 345.611)"
      />
    </g>
  </svg>
);

export default VS;
